export const FULL_SCREEN_MODAL_NAME = 'recommendation-full-screen-filter-modal'
